module.exports = __webpack_public_path__ + "img/registered.4447ff87.png";